module.exports = __webpack_public_path__ + "img/water.4fff67aa.jpg";